module.exports = __webpack_public_path__ + "static/media/ic_bus.ab7b79db.png";